<template>
  <v-dialog
      v-model="showDialog"
      persistent
      max-width="320"
      data-cy="node-deleted-dialog"
  >
    <template v-slot:activator="{ props }">
      <div v-bind="props" data-cy="node-deleted-activator">
        <slot></slot>
      </div>
    </template>

    <v-card data-cy="node-deleted-card">
      <v-card-title class="d-flex justify-space-between">
        <span>
          {{ $t('routes.node.folderDeleted') }}
        </span>
        <v-btn
            icon
            @click="closeAndRedirect"
            data-cy="close-dialog-btn"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="text-body-1 py-4">
        {{ $t('routes.node.OKforRedirect') }}
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            color="primary"
            @click="closeAndRedirect"
            data-cy="redirect-btn"
        >
          {{ $t('common.redirect') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { useNodeStore } from '@/stores/NodeStore.js';
import DialogActionKeys from '@/components/mixin/DialogActionKeys.js';

export default {
  emits: ["update:modelValue"],
  name: 'NodeDeletedDialog',
  mixins: [DialogActionKeys],

  props: {
    modelValue: {
      type: Boolean,
      required: true
    }
  },

  computed: {
    showDialog: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      }
    }
  },

  methods: {
    closeAndRedirect() {
      const nodeStore = useNodeStore();
      const deletedNodeId = nodeStore.getViewNodeDeletedId;
      const activeParentNodeId = nodeStore.findActiveParentNodeIdOfDeletedNode(deletedNodeId);

      if (activeParentNodeId) {
        this.$router.push(`/node/${activeParentNodeId}`);
      } else {
        this.$router.push('/');
      }

      this.showDialog = false;
    }
  }
};
</script>

<style scoped>
.v-card__text {
  font-size: 16px !important;
}
</style>
